import React from "react";

const PAY_RATE_OPTIONS = [
  { value: "hourly_rate", label: "Hourly" },
  // { value: "hourly_rate_1_5_overtime", label: "Hourly (1.5 x Overtime)" },
  // { value: "salary", label: "Salary" },
  // { value: "rates_per_day", label: "Rates per Day" },
  // {
  //   // value: "hourly_rate_44h_1_5_overtime",
  //   // label: "Hourly (44h + 1.5 x Overtime)",
  // },
  // { value: "fixed_rate", label: "Fixed Rate" },
];

const SALARY_PERIODS = [
  { value: "annual", label: "Annual" },
  { value: "monthly", label: "Monthly" },
  { value: "weekly", label: "Weekly" },
];

const SALARY_ALLOCATIONS = [
  { value: "none", label: "No Allocation" },
  { value: "cost_center_1", label: "Cost Center 1" },
  { value: "cost_center_2", label: "Cost Center 2" },
];

export default function PayRatesForm({
  value = {},
  onChange,
  disabled = false,
}) {
  // Helper to update a field and call onChange with the new value object
  const handleChange = (field) => (e) => {
    const newRates = {
      ...value,
      [field]: e.target.value,
    };
    onChange && onChange(newRates);
  };

  // Helper for select changes
  const handleSelectChange = (field) => (e) => {
    const newRates = {
      ...value,
      [field]: e.target.value,
    };
    onChange && onChange(newRates);
  };

  // Default payRateType
  const payRateType = value.payRateType || "hourly_rate";

  return (
    <div className="w-full grid grid-cols-4 my-8">
      <div>
        <label className="block text-sm font-medium mb-1">Pay rates</label>
        <p className="text-xs text-gray-500 mb-2">
          Pay rates include ordinary hours, overtime, loadings and more.{" "}
          <a href="#" className="text-blue-700 underline">
            About pay rates
          </a>
        </p>
      </div>
      <div className="col-span-2">
        <select
          className="w-full rounded border border-gray-300 bg-white p-2 mb-4"
          value={payRateType}
          onChange={handleSelectChange("payRateType")}
          disabled={disabled}
        >
          {PAY_RATE_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>

        {/* Hourly */}
        {payRateType === "hourly_rate" && (
          <div className="bg-gray-50 p-4 rounded mb-2">
            <PayRateInput
              label="Weekday rate"
              value={value.weekday || ""}
              onChange={handleChange("weekday")}
              disabled={disabled}
            />
            <PayRateInput
              label="Saturday rate"
              value={value.saturday || ""}
              onChange={handleChange("saturday")}
              disabled={disabled}
            />
            <PayRateInput
              label="Sunday rate"
              value={value.sunday || ""}
              onChange={handleChange("sunday")}
              disabled={disabled}
            />
            <PayRateInput
              label="Public holiday rate"
              value={value.publicHoliday || ""}
              onChange={handleChange("publicHoliday")}
              disabled={disabled}
            />
          </div>
        )}

        {payRateType === "fixed_rate" && (
          <div className="bg-gray-50 p-4 rounded mb-2">
            <PayRateInput
              label="Hourly rate"
              value={value.fixedRate || ""}
              onChange={handleChange("fixedRate")}
              disabled={disabled}
            />
          </div>
        )}

        {/* Hourly (1.5 x Overtime) */}
        {payRateType === "hourly_rate_1_5_overtime" && (
          <div className="bg-gray-50 p-4 rounded mb-2">
            <PayRateInput
              label="Hourly rate"
              value={value.hourly || ""}
              onChange={handleChange("hourly")}
              disabled={disabled}
            />
            <PayRateInput
              label="Overtime rate"
              value={value.overtime || ""}
              onChange={handleChange("overtime")}
              helpText="(Base rate x 1.5)"
              disabled={disabled}
            />
          </div>
        )}

        {/* Hourly (44h + 1.5 x Overtime) */}
        {payRateType === "hourly_rate_44h_1_5_overtime" && (
          <div className="bg-gray-50 p-4 rounded mb-2">
            <PayRateInput
              label="Hourly rate"
              value={value.hourly44 || ""}
              onChange={handleChange("hourly44")}
              disabled={disabled}
            />
            <PayRateInput
              label="Overtime rate"
              value={value.overtime44 || ""}
              onChange={handleChange("overtime44")}
              helpText="(Base 44h + rate x 1.5)"
              disabled={disabled}
            />
          </div>
        )}

        {/* Salary */}
        {payRateType === "salary" && (
          <div className="bg-gray-50 p-4 rounded mb-2">
            <div className="mb-3">
              <label className="block text-sm font-medium mb-1">
                Salary period
              </label>
              <select
                className="w-full rounded border border-gray-300 bg-white p-2"
                value={value.salaryPeriod || "annual"}
                onChange={handleSelectChange("salaryPeriod")}
                disabled={disabled}
              >
                {SALARY_PERIODS.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
            <PayRateInput
              label="Salary amount"
              value={value.salaryAmount || ""}
              onChange={handleChange("salaryAmount")}
              unit="€"
              disabled={disabled}
            />
            <div className="mb-3">
              <label className="block text-sm font-medium mb-1">
                Salary cost allocation
              </label>
              <select
                className="w-full rounded border border-gray-300 bg-white p-2"
                value={value.salaryAllocation || "none"}
                onChange={handleSelectChange("salaryAllocation")}
                disabled={disabled}
              >
                {SALARY_ALLOCATIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="text-sm text-gray-700">
              Weekly Salary: €
              {value.salaryAmount
                ? ((+value.salaryAmount || 0) / 52).toFixed(2)
                : "0.00"}
            </div>
          </div>
        )}

        {/* Rates per Day */}
        {payRateType === "rates_per_day" && (
          <div className="bg-gray-50 p-4 rounded mb-2">
            {[
              "mondays",
              "tuesdays",
              "wednesdays",
              "thursdays",
              "fridays",
              "saturdays",
              "sundays",
              "publicHolidays",
            ].map((day) => (
              <PayRateInput
                key={day}
                label={capitalize(day.replace(/s$/, ""))}
                value={value[day] || ""}
                onChange={handleChange(day)}
                disabled={disabled}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function PayRateInput({
  label,
  value,
  onChange,
  unit = "€ per hour",
  helpText,
  disabled = false,
}) {
  return (
    <div className="mb-3">
      <label className="block text-sm font-medium mb-1">{label}</label>
      <div className="flex items-center">
        <input
          type="number"
          min="0"
          className="w-full rounded border border-gray-300 p-2"
          value={value}
          onChange={onChange}
          disabled={disabled}
        />
        <span className="ml-2 text-gray-500 text-sm">{unit}</span>
      </div>
      {helpText && <div className="text-xs text-gray-500 mt-1">{helpText}</div>}
    </div>
  );
}

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
